import { useEffect, useState } from 'react';
import * as calls from '../../../store/api/bites-api/calls/contactUs.calls';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../../store/auth/auth.selectors';
import { validateEmail } from '../../../utils/stringValidations';
import { logError, trackEvent } from '../../../store/appActivity/appActivity.slice';
import Toast from 'react-native-toast-message';
import { EToastTypes } from '../../../utils/constants/toastConfig';

const useContactUs = ({ onTicketSent }: { onTicketSent: () => void }) => {
  const dispatch = useDispatch();
  const [subjectValue, setSubjectValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [contentValue, setContentValue] = useState('');
  const [uploadState, setUploadState] = useState({
    sending: false,
    error: false,
  });

  const user = useSelector(userSelector);

  useEffect(() => {
    if (user?.email && validateEmail(user?.email)) {
      setEmailValue(user.email);
    }
  }, [user]);

  const sendTicket = async () => {
    dispatch(
      trackEvent({
        event: 'send',
      }),
    );
    setUploadState({ sending: true, error: false });
    try {
      await calls.sendContactUsTicket({
        subject: subjectValue,
        content: contentValue,
        email: emailValue,
      });
      onTicketSent();
    } catch (error) {
      setUploadState({
        sending: false,
        error: true,
      });

      dispatch(
        logError({
          event: 'sendTicket: error',
          error,
        }),
      );

      Toast.show({
        type: EToastTypes.networkError,
        topOffset: 0,
      });
    }
  };

  return {
    subjectValue,
    setSubjectValue,
    emailValue,
    setEmailValue,
    contentValue,
    setContentValue,
    uploadState,

    sendTicket,
  };
};

export default useContactUs;
